import React from 'react';
import { Link } from 'react-router-dom';
import { formatTimestamp } from '../constants/workflowLabels';

const KIND_LABEL = {
  permit: 'Permit',
  case: 'Case',
  violation: 'Violation',
  status: 'Status',
  audit: 'Audit',
};

/**
 * GOVOPS-1111 — recent operational activity feed for /admin.
 */
const OperationalActivityTable = ({ activities = [] }) => (
  <section className="rhs-card" aria-labelledby="activity-heading">
    <h2 id="activity-heading" className="rhs-card-title">
      Recent operational activity
    </h2>
    <p className="rhs-muted rhs-card-lead">
      Permits created, cases updated, violations filed, and status changes from GovOps.
    </p>

    {activities.length === 0 ? (
      <div className="rhs-empty-state rhs-empty-state--compact">
        <p className="rhs-muted">
          No activity recorded yet. Actions appear here as permits, cases, and violations
          move through the workflow.
        </p>
      </div>
    ) : (
      <div className="rhs-table-wrap">
        <table className="rhs-table rhs-table--activity">
          <thead>
            <tr>
              <th scope="col">When</th>
              <th scope="col">Type</th>
              <th scope="col">Event</th>
              <th scope="col">Detail</th>
              <th scope="col">Record</th>
            </tr>
          </thead>
          <tbody>
            {activities.map((row) => (
              <tr key={row.id} className={`rhs-activity-row rhs-activity-row--${row.kind}`}>
                <td>{formatTimestamp(row.ts)}</td>
                <td>
                  <span className="rhs-activity-kind">{KIND_LABEL[row.kind] || row.kind}</span>
                </td>
                <td>{row.label}</td>
                <td className="rhs-cell-detail">{row.detail || '—'}</td>
                <td>
                  {row.href ? (
                    <Link to={row.href} className="rhs-table-link">
                      {row.entityId ? String(row.entityId).slice(0, 14) : 'View'}
                    </Link>
                  ) : (
                    <span className="rhs-muted">{row.entityId || '—'}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);

export default OperationalActivityTable;
